import styles from './DraftIndicator.module.scss';

interface DraftIndicatorProps {
  lastSaved: Date | null;
}

export function DraftIndicator({ lastSaved }: DraftIndicatorProps) {
  if (!lastSaved) {
    return (
      <div className={styles.draftIndicator}>
        <span className={styles.draftIndicator__dot} />
        <span className={styles.draftIndicator__text}>Unsaved changes</span>
      </div>
    );
  }

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={`${styles.draftIndicator} ${styles['draftIndicator--saved']}`}>
      <span className={`${styles.draftIndicator__dot} ${styles['draftIndicator__dot--saved']}`} />
      <span className={styles.draftIndicator__text}>
        Saved at {formatTime(lastSaved)}
      </span>
    </div>
  );
}
